import './Destinations.css'
import {Card} from "../../components/card/Card";

const web = require('./images/web.png')
const desktop = require('./images/desktop.png')
const server = require('./images/server.png')

function Destinations() {
    return (
        <section className='destinations'>
            <Card
                img={desktop}
                name='Desktop'
                description='Standard.'
                type='dark'
                buttonText='More'
            />

            <Card
                img={web}
                name='Websites'
                description='Affordable.'
                type='light'
                buttonText='More'
            />

            <Card
                img={server}
                name='Servers'
                description='Impenetrability.'
                type='dark'
                buttonText='More'
            />
        </section>
    )
}

export default Destinations